// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#mainDisplay {\r\n  right: 180px;\r\n  width: calc(100% - 180px);\n}\r\n", ""]);
// Exports
module.exports = exports;
